import React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import objectSupport from "dayjs/plugin/objectSupport";
import localizedFormat from "dayjs/plugin/localizedFormat";
import localeData from "dayjs/plugin/localeData";
import weekday from "dayjs/plugin/weekday";
import { FCWithChildren } from "../../types";

dayjs.extend(objectSupport);
dayjs.extend(localizedFormat);
dayjs.extend(localeData);
dayjs.extend(weekday);

export const PickerLocalizationProvider: FCWithChildren = (props) => {
  const { children } = props;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      {children}
    </LocalizationProvider>
  );
};
